export const EXTRA_SMALL_SPACING = `5px`
export const SMALL_SPACING = `10px`
export const MEDIUM_SPACING = `15px`
export const LARGE_SPACING = `20px`
export const EXTRA_LARGE_SPACING = `30px`

export const LAYOUT_SPACING_DESKTOP = `24px`
export const LAYOUT_SPACING_MOBILE = `16px`
